import dayjs from 'dayjs';
import 'dayjs/locale/es';

/** Date of the cycle after a charge, as "10 de abril 2026"; empty when the charge date is unreadable. */
export const getNextBillingDateLabel = (paymentDate: string): string => {
  const date = dayjs(paymentDate);
  if (!date.isValid()) {
    return '';
  }
  return date.add(1, 'month').locale('es').format('D [de] MMMM YYYY');
};
